import React, { Component } from 'react';
import formDataSchema from '../../../schema/bill-tat-report';
import DateRange from '../../../components/FormComponent/DateRange';
import moment from 'moment';

class Bill_TAT_Report extends Component {


    constructor(props) {
        super(props);
        this.state = {
            date: '',
            appTime: [],
            headding: null,
            postdata: {},
            formData: [],
            reportData: [],
            reportHead: [],
            reportExcelData: [],
            visible: false,
            dateTo: moment().format('YYYY-MM-DD'),
            dateFrom: moment().subtract(7, 'd').format('YYYY-MM-DD'),
            activePage: 1,
            totalItems: 0,
            isLoading: false,
            downloadStatus: 0,
            'thead': [],
            'tbody': [],
            search: ""
        };
    }


    componentDidMount() {
        let formSchema = Object.assign({}, formDataSchema);
        formSchema['feilds'].map((feild, key) => {
            formSchema['feilds'][key]['value'] = null;
            formSchema['feilds'][key]['valid'] = false;
            formSchema['feilds'][key]['errors'] = [];
            delete formSchema['feilds'][key]['text'];

        })
        this.setState(({ 'formData': formSchema['feilds'] }))

    }


    render() {
        let { formData } = this.state;
        return (
            <div className="card m-5 card-table">
                <div className="card-header bg8">
                    <div className="clearfix">
                        <div className="float-left pt-1">
                            Bill TAT Report
                    </div>
                        <div className=" row col-xl-3 float-right">
                            {formData
                                .map((feild, key) => {
                                    if (feild.element === 'daterange') {
                                        return (
                                            <div
                                                className={`${feild.className
                                                    ? feild.className
                                                    : 'col '} ${feild.name}`}
                                                key={key}>
                                                <DateRange
                                                    Queuedata={formData}
                                                    selectdata={feild}
                                                    {...this.props}
                                                    {...this.state}
                                                    onselectChanges={(e) => { console.log('onselectChanges:', e.value[0]) }}
                                                />
                                            </div>
                                        )
                                    }
                                })}
                        </div>
                    </div>

                </div>
                <div className="financial-table table-responsive">
                    <table className="table table-hover table-bordered mb-0" id="myTable">
                        <thead>
                            <tr>

                                <td className="text-capitalize">S.no</td>
                                <td className="text-capitalize">Patient Name</td>
                                <td className="text-capitalize">Patient IP</td>
                                <td className="text-capitalize">Patient UMR</td>
                                <td className="text-capitalize">Phone Number</td>
                                <td className="text-capitalize">Date of admitted</td>
                                <td className="text-capitalize">80% reached time</td>
                                <td className="text-capitalize">recounselling done time</td>
                                <td className="text-uppercase">tat</td>
                                <td className="text-capitalize">recounselled by</td>
                                <td className="text-capitalize">recounselled status</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>01</td>
                                <td className="text-capitalize">akhil</td>
                                <td className="text-uppercase">ip1212121212</td>
                                <td className="text-uppercase">UMR123456789</td>
                                <td>9999999999</td>
                                <td className="text-capitalize">06 april 2020</td>
                                <td className="text-capitalize">06 april 2020 10:20am</td>
                                <td className="text-capitalize">06 april 2020 12:20am</td>
                                <td>02:00hrs</td>
                                <td className="text-capitalize">satish</td>
                                <td className="text-capitalize">completed</td>
                            </tr>
                            <tr>
                                <td>02</td>
                                <td className="text-capitalize">akhil</td>
                                <td className="text-uppercase">ip1212121212</td>
                                <td className="text-uppercase">UMR123456789</td>
                                <td>9999999999</td>
                                <td className="text-capitalize">06 april 2020</td>
                                <td className="text-capitalize">06 april 2020 10:20am</td>
                                <td className="text-capitalize">06 april 2020 12:20am</td>
                                <td>02:00hrs</td>
                                <td className="text-capitalize">satish</td>
                                <td className="text-capitalize">completed</td>
                            </tr>
                            <tr>
                                <td>03</td>
                                <td className="text-capitalize">akhil</td>
                                <td className="text-uppercase">ip1212121212</td>
                                <td className="text-uppercase">UMR123456789</td>
                                <td>9999999999</td>
                                <td className="text-capitalize">06 april 2020</td>
                                <td className="text-capitalize">06 april 2020 10:20am</td>
                                <td className="text-capitalize">06 april 2020 12:20am</td>
                                <td>02:00hrs</td>
                                <td className="text-capitalize">satish</td>
                                <td className="text-capitalize">completed</td>
                            </tr>
                            <tr>
                                <td>04</td>
                                <td className="text-capitalize">akhil</td>
                                <td className="text-uppercase">ip1212121212</td>
                                <td className="text-uppercase">UMR123456789</td>
                                <td>9999999999</td>
                                <td className="text-capitalize">06 april 2020</td>
                                <td className="text-capitalize">06 april 2020 10:20am</td>
                                <td className="text-capitalize">06 april 2020 12:20am</td>
                                <td>02:00hrs</td>
                                <td className="text-capitalize">satish</td>
                                <td className="text-capitalize">completed</td>
                            </tr>
                            <tr>
                                <td>05</td>
                                <td className="text-capitalize">akhil</td>
                                <td className="text-uppercase">ip1212121212</td>
                                <td className="text-uppercase">UMR123456789</td>
                                <td>9999999999</td>
                                <td className="text-capitalize">06 april 2020</td>
                                <td className="text-capitalize">06 april 2020 10:20am</td>
                                <td className="text-capitalize">06 april 2020 12:20am</td>
                                <td>02:00hrs</td>
                                <td className="text-capitalize">satish</td>
                                <td className="text-capitalize">completed</td>
                            </tr>
                            <tr>
                                <td>06</td>
                                <td className="text-capitalize">akhil</td>
                                <td className="text-uppercase">ip1212121212</td>
                                <td className="text-uppercase">UMR123456789</td>
                                <td>9999999999</td>
                                <td className="text-capitalize">06 april 2020</td>
                                <td className="text-capitalize">06 april 2020 10:20am</td>
                                <td className="text-capitalize">06 april 2020 12:20am</td>
                                <td>02:00hrs</td>
                                <td className="text-capitalize">satish</td>
                                <td className="text-capitalize">completed</td>
                            </tr>
                            <tr>
                                <td>07</td>
                                <td className="text-capitalize">akhil</td>
                                <td className="text-uppercase">ip1212121212</td>
                                <td className="text-uppercase">UMR123456789</td>
                                <td>9999999999</td>
                                <td className="text-capitalize">06 april 2020</td>
                                <td className="text-capitalize">06 april 2020 10:20am</td>
                                <td className="text-capitalize">06 april 2020 12:20am</td>
                                <td>02:00hrs</td>
                                <td className="text-capitalize">satish</td>
                                <td className="text-capitalize">completed</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        )
    }
}
export default Bill_TAT_Report